import axios from 'axios';
import {config} from '@/config.js'

const token = localStorage.getItem('token');
const language = localStorage.getItem('lang');

const piincHttp = axios.create({
  baseURL: config.baseApiUrl,
  params: {},
  headers: {
      'Authorization': 'Bearer ' + token,
      'Language': language
  }
});

export default piincHttp;
